// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as FetchCallerDetailsDm from "../../data-machine/FetchCallerDetailsDm.bs.js";
import * as MobileNumberValidation from "../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as PretendAsCallerSearchCmp from "./PretendAsCallerSearchCmp.bs.js";
import * as PretendAsCallerRepoManager from "../../repo/PretendAsCallerRepoManager.bs.js";
import * as PretendAsCallerAssetsManager from "../assets/PretendAsCallerAssetsManager.bs.js";
import * as PretendAsCallerSearchResultCmp from "./PretendAsCallerSearchResultCmp.bs.js";

PretendAsCallerAssetsManager.importCss(undefined);

function PretendAsCallerDashboardCmp(Props) {
  var phone_number = Props.phone_number;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        
      });
  var setCallerNumber = match$1[1];
  var callerNumber = match$1[0];
  var match$2 = React.useState(function () {
        return /* Init */0;
      });
  var setCallerDetail = match$2[1];
  React.useEffect((function () {
          if (phone_number !== undefined) {
            var match = MobileNumberValidation.executeWithoutCode(phone_number, country);
            if (match.TAG === /* Ok */0) {
              Curry._1(setCallerNumber, (function (param) {
                      return phone_number;
                    }));
            }
            
          }
          
        }), []);
  React.useEffect((function () {
          PretendAsCallerRepoManager.getRepo(undefined);
          if (callerNumber !== undefined) {
            Curry._1(setCallerDetail, (function (param) {
                    return {
                            TAG: /* Loading */0,
                            _0: undefined
                          };
                  }));
            FetchCallerDetailsDm.execute(callerNumber, (function (data) {
                    return Curry._1(setCallerDetail, (function (param) {
                                  return {
                                          TAG: /* Live */1,
                                          _0: data
                                        };
                                }));
                  }), (function (error) {
                    return Curry._1(setCallerDetail, (function (param) {
                                  return {
                                          TAG: /* Error */2,
                                          _0: error
                                        };
                                }));
                  }), country);
          }
          
        }), [callerNumber]);
  return React.createElement("div", undefined, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "c-pretend-as-caller-dashboard"
                }, React.createElement(PretendAsCallerSearchCmp.make, {
                      callerNumber: callerNumber,
                      setCallerNumber: setCallerNumber
                    }), React.createElement(PretendAsCallerSearchResultCmp.make, {
                      callerNumber: callerNumber,
                      callerDetail: match$2[0]
                    })));
}

var make = PretendAsCallerDashboardCmp;

export {
  make ,
  
}
/*  Not a pure module */
